export const eatingWayFeatureTranslationEN = {};
